import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Grid, Typography, Link, Stack, Divider, Container } from '@mui/material';
import { Phone, Email, Smartphone } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import Logo from "./Logo";

const Footer = () => {
  const { isAuthenticated } = useAuth();
  const certificatePath = isAuthenticated ? '/AvailableCourses' : '/login';
  return (
    <Box component="footer" sx={{ backgroundColor: '#1a1a1a', color: '#fff', py: { xs: 4, md: 5 } }}>
      <Container maxWidth="lg">
      <Grid container spacing={{ xs: 3, md: 4 }}>

        {/* Logo y Descripción */}
        <Grid item xs={12} md={5}>
          <Box mb={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: "center", md: "flex-start" } }}>
            <Logo display={{ xs: "flex", md: "flex" }} />
          </Box>
          <Typography variant="body2" sx={{ textAlign: { xs: "center", md: "left" }, color: "grey.300", lineHeight: 1.7 }}>
            Plataforma web desarrollada para capacitar y motivar a las comunidades en el manejo adecuado de polímeros y biopolímeros.
            Utiliza cursos e-learning, microlearning entre otros métodos para fomentar la conciencia ambiental y promover prácticas sostenibles de reciclaje.
          </Typography>
        </Grid>

        {/* Información de Contacto */}
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="h6" gutterBottom>Información de contacto</Typography>
          <Stack spacing={2}>
            <Typography variant="body2" sx={{ color: "grey.300" }}>
              <Phone fontSize="small" sx={{ mr: 1 }} />
              +57-3156066418
            </Typography>
            <Typography variant="body2" sx={{ color: "grey.300" }}>
              <Smartphone fontSize="small" sx={{ mr: 1 }} />
              +57-3156066418
            </Typography>
            <Typography variant="body2" sx={{ color: "grey.300" }}>
              <Email fontSize="small" sx={{ mr: 1 }} />
              <Link href="mailto:marojasm@etitc.com.co" underline="hover" color="inherit">
                marojasm@etitc.com.co
              </Link>
            </Typography>
          </Stack>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" gutterBottom>Enlaces rápidos</Typography>
          <Stack spacing={1.25}>
            <Link href="/AboutUs" underline="hover" color="grey.300">Acerca de nosotros</Link>
            <Link href="/EvidenceResults" underline="hover" color="grey.300">Evidencias y resultados</Link>
            <Link href="/NewsEvents" underline="hover" color="grey.300">Noticias y eventos</Link>
            <Link component={RouterLink} to={certificatePath} underline="hover" color="grey.300">Certifícate</Link>
          </Stack>
        </Grid>
      </Grid>

      {/* Separador inferior */}
      <Divider sx={{ backgroundColor: '#333', marginY: 3 }} />

      {/* Pie de página */}
      <Typography variant="body2" color="grey.500" align="center">
        © {new Date().getFullYear()} ETITC / BioPlastic. Todos los derechos reservados.
      </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
